module.exports = __webpack_public_path__ + "static/media/neurology.333d32bb.svg";